var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from "react";
import Button from "../../Ui/Button";
import { useForm } from "react-hook-form"; //https://react-hook-form.com/get-started
import ErrorMessage from "../../ErrorMsg";
import { FormStyled } from "./style";
import PowerByEpayco from "../../PowerByEpayco";
import InputLayout from "../../InputLayout";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getInvoiceClear, getInvoiceSuccess, } from "../../../redux/actions/invoiceActions";
import InvoiceService from "../../../services/invoicesServices";
import ErrorModal from "../../Modals/ErrorModal";
import config from "../../../config/enviroment";
import { useSelector } from "react-redux";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
var QueryForm = function () {
    var executeRecaptcha = useGoogleReCaptcha().executeRecaptcha;
    var recapcha = useSelector(function (state) { return state.recaptcha; });
    var _a = useState(''), recaptchaToken = _a[0], setRecaptchaToken = _a[1];
    var invoiceService = new InvoiceService();
    var dispatch = useDispatch();
    var navigate = useNavigate();
    var _b = useState(false), isLoading = _b[0], setisLoading = _b[1];
    var _c = useState(false), isError = _c[0], setIsError = _c[1];
    var _d = useState(false), ShowErrorModal = _d[0], setShowErrorModal = _d[1];
    var refOrNumber = useParams().refOrNumber;
    var search = useLocation().search;
    var refOrNumberSL = new URLSearchParams(search).get("refOrNumber");
    if (localStorage.getItem('typeInvoice')) {
        localStorage.removeItem('typeInvoice');
    }
    var _e = useForm({ mode: "onChange" }), register = _e.register, handleSubmit = _e.handleSubmit, watch = _e.watch, errors = _e.formState.errors, setValue = _e.setValue;
    var value = watch("refOrNumber");
    useEffect(function () {
        if (refOrNumber) {
            setValue("refOrNumber", refOrNumber);
            var data = {
                refOrNumber: refOrNumber,
                channel: "SmartLink",
            };
            onSubmit(data);
        }
        if (refOrNumberSL) {
            setValue("refOrNumber", refOrNumberSL);
            var data = {
                refOrNumber: refOrNumberSL,
                channel: "SmartLink",
            };
            onSubmit(data);
        }
    }, [recapcha]);
    var onSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var token, dataInvoices;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    token = '';
                    setisLoading(true);
                    setIsError(false);
                    return [4 /*yield*/, invoiceService.getInvoices(data.refOrNumber, token)];
                case 1:
                    dataInvoices = _a.sent();
                    if (dataInvoices) {
                        if (dataInvoices.length) {
                            dataInvoices.elements = dataInvoices.length;
                        }
                        if (data.channel) {
                            dataInvoices.channel = data.channel;
                        }
                        else {
                            dataInvoices.channel = "Web";
                        }
                        dispatch(getInvoiceSuccess(dataInvoices));
                        if (dataInvoices.total > 0 || dataInvoices.length > 0) {
                            navigate("/pago");
                        }
                        else {
                            setShowErrorModal(true);
                        }
                    }
                    else {
                        setIsError(true);
                    }
                    setisLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var validateRefOrNumber = function () {
        var valueInput = watch("refOrNumber");
        if (valueInput == undefined)
            return true;
        if (valueInput == "")
            return true;
        return errors.refOrNumber != null;
    };
    var onEnter = function (event) {
        if (event.key === "Enter")
            event.preventDefault;
    };
    var cancelEventDefault = function (e) {
        e.preventDefault();
    };
    var validateNumber = function () {
        var valueInput = watch("refOrNumber");
        var regex = /^[0-9]+$/;
        if (!regex.test(valueInput)) {
            setValue("refOrNumber", valueInput.substring(0, valueInput.length - 1));
        }
    };
    return (React.createElement(FormStyled, null,
        ShowErrorModal && (React.createElement(ErrorModal, { type: value.length > 10 ? "error" : "errorPhone", onClick: function () {
                navigate("/pago");
            }, onExit: function () {
                dispatch(getInvoiceClear({
                    isLoading: false,
                }));
                setShowErrorModal(false);
            } })),
        React.createElement("div", { className: "principalTitleQuery" }, "\u00A1Paga f\u00E1cil y seguro!"),
        React.createElement("form", { autoComplete: "off", onSubmit: cancelEventDefault },
            React.createElement(InputLayout, null,
                React.createElement("img", { src: config.urlS3 + "/wom/icons/phone.png", alt: "phone icon" }),
                React.createElement("input", __assign({ type: "text", maxLength: 15, className: 'queryPlaceholder', placeholder: "N\u00FAmero de l\u00EDnea o referencia \u00FAnica de pago" }, register("refOrNumber", {
                    required: true,
                    minLength: 5,
                    maxLength: 15,
                    onChange: function (e) {
                        validateNumber();
                    },
                }), { onKeyDown: function () { return onEnter; } }))),
            isError && (React.createElement(ErrorMessage, null, "La informaci\u00F3n que ingresaste no es correcta. Verifica nuevamente tus datos y consulta de nuevo.")),
            React.createElement("div", { className: "button-container" },
                React.createElement(Button, { loading: isLoading, disabled: validateRefOrNumber(), onClick: handleSubmit(onSubmit) }, "IR A PAGAR"))),
        React.createElement(PowerByEpayco, null)));
};
export default QueryForm;
